<template>
    <div id="personal_intru">
        <div class="close-btn">
            <button @click="close"><v-img src="@/assets/img/closeButton2.svg"></v-img></button>
        </div>
        <div class="content-wrap">
            <div class="title"><p>한 마리의 새가 날아와 손바닥에 앉는다면</p></div>
            <div class="content">
                지저귀는 소리가 들린다. 그것을 따라 수백 마리의 새들이 있는 정원에 들어선다면, 쫑쫑거리고 물을 마시고 하늘을 한 바퀴 도는 일에 너무 바쁜 새들이 있는 정원으로 걸어 들어간다면. 존재하는 것만으로도 스스로의 욕망을 다하는 생물을 보는 황홀한 슬픔에 우두커니 선다. 그럴 때 단 한 마리의 새가 먹이를 쥐지 않은 나에게로 날아온다면…. 
<br>
<br>
소울 메이트라는 단어가 유행하던 시절이었다. 텔레비전 드라마 제목으로 사용된 여파인 것 같았다. 후천적으로 만들어진 관계를 설명하는 단어가 그렇듯이 정확한 형태가 없었다. 어떤 사람들은 베스트 프렌드에게 소울 메이트라는 명칭을 할애했다. 누군가는 마음의 비어있는 공간을 메울 클레이처럼 사용하는 것 같았다. 세상을 대하는 태도에 있어서 본인과 가장 닮은 사람을 그렇게 부르기도 했다. 
<br>
<br>
나의 경우는, 그걸 신포도처럼 대했다. 절절히 필요하지만 불확실성을 핑계로 입에 올리지 않았다. 나의 영혼도 어떤 형태인지 알 수 없는데, 어떻게 타인의 영혼을 감별해서 나와 맞다 아니다 결정하겠는가. 만약 소울 메이트를 감별하는 자가진단 문항이라도 있었다면 조금 더 수월했을 것이다.
<br>
<br>
그런 의미에서 음향원의 방송부가 준비한 축제 콘텐츠는 나 같은 회의론자들마저도 대기 줄에 서게 만드는 것이었다. 
<br>
<br>
[당신의 사운드 메이트를 찾아드립니다]
<br>
<br>
그들의 캐치프레이즈였다. 원리는 단순했으나 흥미를 끌었다. 사실은 원리라고 할 만한 것이 있었기 때문에 특별하게 여겨졌는지도 모른다. 적어도 별자리나 이름점, 타로카드 리딩보다는 독창적이었다. 진행 과정마저도 별 품이 안 들었다. 교실 하나를 빌려 그곳은 완전한 암실로 만든다. 그리고는 한 명씩 들여보낸다. 
<br>
<br>
1 헤르츠부터 기가헤르츠까지의 단위를 사용하며, 그 안에서도 20 헤르츠에서 20 킬로미터 사이는 생략한다. 그 부분은 사람들이 가장 평균적으로 들을 수 있는 범위이다. 보편적이기 때문에 저항이 없는 속성은 우리가 찾고자 하는 무엇이 아니다. 방송부는 그 바깥 영역의 주파수를 사용하여 사운드 메이트 찾기 프로그램을 진행했다. 
<br>
<br>
장애물을 비워둔 암실에 들어가서 텅 빈 공간에 선다. 눈을 감고 청각에만 집중한다. 그 순간 새들이 일제히 날아오르는 것처럼 10초간의 음성을 들려준다. 다양한 주파수로 녹음되고 송출하는 수백 개의 단어들이 겹치도록 방 전체를 소리로 채운다. 인간을 관통하거나 그에게 흡수되지 않으며, <span class="sound_text_visited" :class="{'sound-text' : visited[6] === 'disabled'}" @click="play('파동')">파동들이 그를 균일한 간격으로 감싼다.</span>
<br>
<br>
진동수가 많다는 건 저음과 고음의 문제이지 음량을 관장하는 건 아니다. 그래서 암실에서의 순간에 큰 소리를 견뎌야하지는 않았다. 단지 가느다란 이파리가 많은 나무들이 일시에 가지를 흔드는 것과도 같았다. 파스스, 파스스스, 보이지 않는 진동이 몸 안의 피를 흔드는 소리에 멀미가 날 때까지. 가장 강렬하게 들리는 단어를 감각한다. 
<br>
<br>
그러면 방송부는 축제가 끝난 뒤 같은 단어를 들은 사람들에게 서로의 인적사항을 알려주었다. 이것을 사운드 메이트라고 칭했다. 사운드 메이트는 한동안 우리 학교 내에서 붐이었다. 추가 참여 요청이 지나치게 많이 들어와서 축제 다음 날 방과 후 시간을 활용하여 하루를 더 운영해줬다. 
<br>
<br>
그곳에서 내 손바닥에 앉은 한 마리의 새는, ‘<span class="sound_text_visited" :class="{'sound-text' : visited[7] === 'disabled'}" @click="play('우표')">우표</span>’이다. 일부러 다소 로맨틱한 단어들을 특정해준 걸까? 생각했지만, <span class="sound_text_visited" :class="{'sound-text' : visited[8] === 'disabled'}" @click="play('호저')">가운데 손가락</span>이나 <span class="sound_text_visited" :class="{'sound-text' : visited[9] === 'disabled'}" @click="play('관제실')">관제실</span>처럼 우리가 한데 묶을 수 없는 단어들도 숱하게 증언됐다. <span class="sound_text_visited" :class="{'sound-text' : visited[10] === 'disabled'}" @click="play('야호')">야호</span>라는 상쾌한 느낌의 단어도 있어서, 이 감탄사를 운명의 단어로 받은 친구는 암실에서 걸어 나올 때 다소 어리둥절했다고 한다. 단어는 한국어에서만 한정되지도 않았다. 
<br>
<br>
“콘파이?”
<br>
<br>
이분도 우리가 머리를 모아 단어를 궁리해줘야 했던 사람 중 한명이다. 방송부에서는 일단 매칭을 모두 끝내고 연락을 주겠다고 그랬다. 짝이 맞지 않는 사람들 중 흡사하게 들리는 사례를 따로 분류해서 맞춰보겠다고. 콘파이 친구의 단어는 <span class="sound_text_visited" :class="{'sound-text' : visited[11] === 'disabled'}" @click="play('컴파일')">compile</span>이었다. 사운드 메이트 프로그램에 관한 기억들은 우리가 채널헤드를 찾게 된 시발점이다.
<br>
<br>
            </div>
        </div>
    </div>
</template>
<script>
import eventBus from '@/plugins/eventbus.js'
import store from "@/store/index.js";

export default {
  name: 'index_four',
  data() {
    return {
        visited : {
            6: store.getters['getMusicIconUsable'](6),
            7: store.getters['getMusicIconUsable'](7), 
            8: store.getters['getMusicIconUsable'](8),
            9: store.getters['getMusicIconUsable'](9),
            10: store.getters['getMusicIconUsable'](10),
            11: store.getters['getMusicIconUsable'](11),
        },
        
    }
  },
  methods: {
    close() {
        this.$emit("btnclose");
    },
    play(message) {

        switch(message) {
            case '파동' :      
                this.visited[6] = 'active'
                store.commit("toggleText", 6)
                eventBus.$emit("iconUsable", 6); 
                
                break; 
            case "우표" :
                this.visited[7] = 'active'
                store.commit("toggleText", 7)
                eventBus.$emit("iconUsable", 7); 
                
                break;
            case "호저" :
                this.visited[8] = 'active'
                store.commit("toggleText", 8)
                eventBus.$emit("iconUsable", 8);
                break;
            case "관제실" :
                this.visited[9] = 'active'
                store.commit("toggleText", 9)
                eventBus.$emit("iconUsable", 9); 
                break;
            case "야호" :
                this.visited[10] = 'active'
                store.commit("toggleText", 10)
                eventBus.$emit("iconUsable", 10); 
                break;
            case "컴파일" :
                this.visited[11] = 'active'
                store.commit("toggleText", 11)
                eventBus.$emit("iconUsable", 11); 
                break;
        }
    }
  }
}
</script>

<style scoped>
::-webkit-scrollbar {
display: none;
}

#personal_intru {
  box-sizing: border-box;

  position: absolute;
  height: 649px;
  width: 500px;

  border-radius: 20px;
  border: 1px solid rgba(0, 0, 0, 0.6);

  background: rgba(26, 26, 26, 0.9);
  box-shadow: 0px 4px 40px rgba(0, 0, 0, 0.6);
  backdrop-filter: blur(40px);
  /* Note: backdrop-filter has minimal browser support */

  border-radius: 20px;

  left: 606px;
  top: 200px;

  text-align: center;
}

.close-btn {
    position: relative;
    height: 16px;
    width: 16px;
    left: 16px;
    top: 16px;
    border-radius: 16px;
}

.content-wrap {
    position : relative;

    left: 60px;
    top: 64px;
    height: 569px;
    width: 380px;

    overflow-y: scroll;
}

.title {
    font-style: normal;
    font-weight: 700;
    font-size: 20px;
    line-height: 24px;
    /* identical to box height */

    text-align: center;

    color: #F1F1F1;

}

.content {
    margin-top: 58px;

    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    line-height: 200%;
    /* or 36px */

    text-align: justify ;
    color: #F1F1F1;

}

@media (max-width: 600px) {

    #personal_intru {
        top: 500px;
        left: 0;
        width: 100vw;
        height: 600px;
        
    }

    .content-wrap {
        left: 45px;
        width: 310px;
        height: 510px;
    }
    
    .title {
        font-weight: 700;
        font-size: 18px;
        line-height: 22px;
        color: #EAEAEA;


    }

    .content {
        width: 310px;
        height: 510px;
        font-weight: 600;
        font-size: 14px;
        line-height: 200%;
        color: #EAEAEA;

    }
}

</style>